import React from "react";
import Link from "next/link";

export default function Breadcrumbs({ companyData }) {
  return (
    <div className=" breadcrumbs xl:container  mx-auto mt-10 mb-10">
      <div className="mb-6 text-sm text-1B51CA">
        <Link href="/" className=" pr-2 hover:underline">
          {/* Apply className directly to Link */}
          Home
        </Link>
        🔹
        <Link href="/stocks" className="pr-2 pl-2 hover:underline">
          Stocks
        </Link>
        🔹
        <Link href="#" className="text-1A2C45 pl-2">
          {companyData?.name}
        </Link>
      </div>
    </div>
  );
}
